export default "__VITE_ASSET__Ct1FOAPQ__"